import { useEffect, useState } from "react";
import { treinoObjetivoApi } from "../../services/Api";

export const capitalizeFirstLetter = (str) =>
  str.toLowerCase().replace(/(^| )(\w)/g, (s) => s.toUpperCase());

export const useTreinoObjetivos = () => {
  const [state, setState] = useState([]);

  const fetchTreinoObjetivo = async () => {
    const response = await treinoObjetivoApi.getList();
    if (response.ok) {
      setState(
        response.data.map((item) => ({
          label: capitalizeFirstLetter(item.nome),
          value: item.id,
        }))
      );
    }
  };

  useEffect(() => {
    fetchTreinoObjetivo();
  }, []);

  return state;
};
